var _path, _path2;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImage(_ref, svgRef) {
  let title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "add_photo_alternate_black_24dp",
    xmlns: "http://www.w3.org/2000/svg",
    width: 54.259,
    height: 54.259,
    viewBox: "0 0 54.259 54.259",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_61965",
    "data-name": "Path 61965",
    d: "M0,0H54.259V54.259H0Z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_61966",
    "data-name": "Path 61966",
    d: "M39.173,13.3v6.76s-4.5.023-4.522,0V13.3H27.869s.023-4.5,0-4.522h6.782V2h4.522V8.782h6.782V13.3ZM32.39,22.347V15.565H25.608V8.782H7.522A4.535,4.535,0,0,0,3,13.3v27.13a4.535,4.535,0,0,0,4.522,4.522h27.13a4.535,4.535,0,0,0,4.522-4.522V22.347ZM7.522,40.433,14.3,31.39l4.522,6.782,6.782-9.043,9.043,11.3Z",
    transform: "translate(3.782 2.522)",
    fill: "#828282"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage);
export default __webpack_public_path__ + "static/media/Image.efeccc2b6268764d0b2bb65cae753949.svg";
export { ForwardRef as ReactComponent };